import axios from 'axios'

export class Api extends Error {
  constructor(message) {
    super(`Api Error: ${message}`)
  }
}

export class Domain extends Error {
  constructor(message) {
    super(`Domain Error: ${message}`)
  }
}

export default class ErrorMessage {
  message(error, msg) {
    if (axios.isAxiosError(error)) {
      const { status } = error.response
      const messageResponse = error.response.data.message
      if (status >= 400 && status < 500) {
        throw new Domain(messageResponse)
      }
      if (status >= 500) {
        throw new Api(messageResponse)
      }
      return new Error(msg)
    }
  }
}
